module.exports = __webpack_public_path__ + "img/count-img3.26055af8.png";